import { all, fork } from 'redux-saga/effects';
import authSaga from './auth/authSaga';
import usersSaga from './users/usersSaga';
import companiesSaga from './companies/companiesSaga';
import companyProfileSaga from './companyProfile/companyProfileSaga';
import surveysSaga from './surveys/surveysSaga';
import customizeTemplateSaga from './customizeTemplate/customizeTemplateSaga';
import aiTemplateSaga from './aiTemplate/aiTemplateSaga';
import apiLogsSaga from './apiLogs/apiLogsSaga';
import accessLogsSaga from './accessLogs/accessLogsSaga';
import processesSaga from './processes/processesSaga';
import devicesSaga from './devices/devicesSaga';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(usersSaga),
    fork(companiesSaga),
    fork(companyProfileSaga),
    fork(surveysSaga),
    fork(customizeTemplateSaga),
    fork(aiTemplateSaga),
    fork(apiLogsSaga),
    fork(accessLogsSaga),
    fork(processesSaga),
    fork(devicesSaga),
  ]);
}
